/**
 * @generated SignedSource<<d1c2ad413ce652c570464f5fe53e61f3>>
 * @relayHash f16b3e204ec39bfa9d43c285fb425425
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 803091d0ff0618d0995a2b6079d8b642bd8973b80d3025575e4adb7ac82984b2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessEmbedSummarySpaAppsQuery } from './BusinessEmbedSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessEmbedSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "803091d0ff0618d0995a2b6079d8b642bd8973b80d3025575e4adb7ac82984b2",
    "metadata": {},
    "name": "BusinessEmbedSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
